import React, { useContext, useEffect } from 'react'
import { ConfigContext } from '../../../context/configContext'
import { Button, message } from 'antd'
import { generatePath, useHistory } from 'react-router-dom'
import { ADMIN_PARTNER_PAGE } from '../../../routes'
import { useMutateAdminPartnerVerification } from '../../../api/react-query/adminPartners'

function AssignPartnerButton () {
  const { isCoordinator, isPartnerSupport, isExternalCoordinator, user } = useContext(ConfigContext)
  const history = useHistory()

  const {
    mutate: assignPartner,
    data: dataPartnerVerification,
    isSuccess: isSuccessVerification,
    isError: isErrorVerification,
    isLoading: isLoadingVerification,
    error: errorVerification
  } = useMutateAdminPartnerVerification()

  useEffect(() => {
    if (isSuccessVerification && dataPartnerVerification?.isSuccess) {
      history.replace(generatePath(ADMIN_PARTNER_PAGE, { id: dataPartnerVerification.partnerId }))
    } else if (isErrorVerification && !dataPartnerVerification?.isSuccess) {
      message.error(errorVerification?.response?.data?.errorMessage || 'Ошибка получения данных о партнере')
    }
  }, [isSuccessVerification, isErrorVerification, dataPartnerVerification, errorVerification])

  const handleClick = () => {
    assignPartner()
  }

  if (!((isCoordinator || isExternalCoordinator) && !isPartnerSupport && user?.online)) {
    return null
  }

  return (
    <Button
      loading={isLoadingVerification}
      onClick={handleClick}
    >
      Взять анкету
    </Button>
  )
}

export default AssignPartnerButton
